import axios from 'axios'
import * as utils from './apiUtils'

export default {
  getAll() {
    return axios.get(utils.getApiUrl('/masters'))
  },
}
